import React, { useRef, useEffect, useState } from 'react'
import classnames from 'classnames'

import {
  IWorkspace,
} from '@SiteModules/Workspace/types'

import './WorkspaceRow.scss'

interface WorkspaceRowProps {
  readonly index: number
  readonly workspace: IWorkspace
  readonly selected: boolean
  readonly numberOfWorkspaceUsers: number
  changeSelectedWorkspaces(e: React.ChangeEvent<HTMLInputElement>, workspaceId: number): void
  setOpenedWorkspaceId(openedWorkspaceId: number): void
}

const WorkspaceRow: React.FC<WorkspaceRowProps> = props => {
  const {
    index,
    selected,
    workspace,
    numberOfWorkspaceUsers,
  } = props

  const {
    id,
    attributes,
  } = workspace

  const {
    name,
    createdAt,
    numberOfProjects,
  } = attributes

  const [hovering, setHovering] = useState(false)
  const checkboxRef = useRef<HTMLLabelElement | null>(null)

  useEffect(() => {
    if (selected) {
      checkboxRef.current?.style?.setProperty('visibility', 'visible')
    } else if (!hovering) {
      checkboxRef.current?.style?.setProperty('visibility', 'hidden')
    }
  }, [selected])

  const onMouseEnter = () => {
    checkboxRef.current?.style?.setProperty('visibility', 'visible')
    setHovering(true)
  }

  const onMouseLeave = () => {
    setHovering(false)
    if (selected) { return }

    checkboxRef.current?.style?.setProperty('visibility', 'hidden')
  }

  const handleWorkspaceSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.changeSelectedWorkspaces(e, id)
  }

  const handleOpenWorkspace = () => {
    props.setOpenedWorkspaceId(id)
  }

  const renderCheckbox = () => {
    return (
      <label className="WorkspacesTable__checkbox" ref={checkboxRef}>
        <input
          type="checkbox"
          onChange={handleWorkspaceSelection}
          checked={selected}
        />
        <div className="WorkspacesTable__checkmark" />
      </label>
    )
  }

  return (
    <tr
      className={classnames(
        { 'WorkspaceRow__even': index % 2 === 0 },
        { 'WorkspaceRow__uneven': index % 2 === 1 }
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <td className="WorkspacesTable__check">
        {renderCheckbox()}
      </td>
      <td
        className="WorkspacesTable__workspace WorkspaceRow__workspace WorkspaceRow__link"
        onClick={handleOpenWorkspace}
      >
        {name}
      </td>
      <td
        className="WorkspacesTable__members WorkspaceRow__members WorkspaceRow__link"
        onClick={handleOpenWorkspace}
      >
        {numberOfWorkspaceUsers}
      </td>
      <td
        className="WorkspacesTable__projects WorkspaceRow__projects WorkspaceRow__link"
        onClick={handleOpenWorkspace}
      >
        {numberOfProjects}
      </td>
      <td
        className="WorkspacesTable__creation_date WorkspaceRow__creation_date WorkspaceRow__link"
        onClick={handleOpenWorkspace}
      >
        {createdAt}
      </td>
    </tr>
  )
}

export default WorkspaceRow
